<div class="user-list-component" [matTooltip]="getUserHint()">
    <span><mat-icon class="eye-icon">visibility</mat-icon></span>
    <span>{{ text }}: {{ onlineCount }}</span>
</div>
